import React from 'react'

import { SvgImage } from '@/components/Common/SvgImage'

export interface Image {
  as: string
  src: string
  color?: string
}

export const LogoImage = ({ image }: { image: Image }) => {
  switch (image.as) {
    case 'svg':
      return <SvgImage svg={image.src} />
    case 'img':
      return <img src={image.src} />
    default:
      return null
  }
}
